// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .item-box {
  border: 0 !important;
}

.props-grid ion-card {
  cursor: pointer;
}
.props-grid ion-card.active {
  background: var(--button-a-background);
  color: var(--button-a-text);
}

ion-slide {
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}

ion-list {
  height: 100%;
  overflow: auto;
}

ion-buttons.actions_bar {
  margin: 5px auto;
  gap: 2px;
  background: #fdfdfd;
  padding: 2px;
  justify-content: center;
}
ion-buttons.actions_bar ion-button {
  font-size: 30px;
}
ion-buttons.actions_bar ion-input {
  border: 1px solid #ccc;
  max-width: 102px;
  --padding-start: 0;
  --padding-top: 5px;
  --padding-bottom: 5px;
  text-align: center;
}

ion-spinner.big {
  width: 100px;
  height: 70px;
  margin: 20px 10px;
}

.prop-card {
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.sub_slides {
  width: 130%;
}
.sub_slides ion-slide {
  padding: 5px;
}
.sub_slides ion-slide ion-card {
  width: 100%;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/item/pages/filter-res-page/filter-res-page.component.scss"],"names":[],"mappings":"AACE;EACE,oBAAA;AAAJ;;AAKE;EACE,eAAA;AAFJ;AAKE;EACE,sCAAA;EACA,2BAAA;AAHJ;;AAOA;EACE,uBAAA;EACA,sBAAA;EACA,2BAAA;AAJF;;AAOA;EACE,YAAA;EACA,cAAA;AAJF;;AAOA;EACE,gBAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;AAJF;AAME;EACE,eAAA;AAJJ;AAOE;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AALJ;;AASA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;AANF;;AASA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AANF;;AASA;EACE,WAAA;AANF;AAOE;EACE,YAAA;AALJ;AAMI;EACE,WAAA;EACA,SAAA;AAJN","sourcesContent":["::ng-deep {\n  .item-box {\n    border: 0 !important;\n  }\n}\n\n.props-grid {\n  ion-card {\n    cursor: pointer;\n  }\n\n  ion-card.active {\n    background: var(--button-a-background);\n    color: var(--button-a-text);\n  }\n}\n\nion-slide {\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\nion-list {\n  height: 100%;\n  overflow: auto;\n}\n\nion-buttons.actions_bar {\n  margin: 5px auto;\n  gap: 2px;\n  background: #fdfdfd;\n  padding: 2px;\n  justify-content: center;\n\n  ion-button {\n    font-size: 30px;\n  }\n\n  ion-input {\n    border: 1px solid #ccc;\n    max-width: 102px;\n    --padding-start: 0;\n    --padding-top: 5px;\n    --padding-bottom: 5px;\n    text-align: center;\n  }\n}\n\nion-spinner.big {\n  width: 100px;\n  height: 70px;\n  margin: 20px 10px;\n}\n\n.prop-card {\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.sub_slides{\n  width: 130%;\n  ion-slide{\n    padding: 5px;\n    ion-card{\n      width: 100%;\n      margin: 0;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
